export interface AmazonTaktWindow extends Window {
  AmazonTakt?: {
    logCustom?: (a: { context: string, details: string }) => void;
  };
}

function logWithTakt(context: string, details: Record<string, unknown>) {
  (window as AmazonTaktWindow)?.AmazonTakt?.logCustom?.({
    context,
    details: JSON.stringify(details),
  });
}

export default logWithTakt;
